// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `chart-custom-categories-component{height:100%}chart-custom-categories-component .chart-custom-categories-component{height:100%}`, "",{"version":3,"sources":["webpack://./src/shared/components/chart-custom-categories/themes/chart-custom-categories.component.scss"],"names":[],"mappings":"AAEA,kCACI,WAAA,CAEA,qEACI,WAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
